import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminMomentsSettings = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/moments/settings/show.vue')
    createVueApp(ShowPage, { props })
  }
}
